import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RpsToastHostComponent } from './shared/components/toast-host/rps-toast-host.component';
import { DijuChatWidgetComponent } from './shared/components/diju-chat-widget/diju-chat-widget.component';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RpsToastHostComponent, DijuChatWidgetComponent],
  template: `
    <router-outlet />
    <rps-toast-host />
    @if (auth.currentUser()) {
      <rps-diju-chat-widget />
    }
  `
})
export class App {
  auth = inject(AuthService);
}
